import React from "react";
import { ResponsiveBar } from "@nivo/bar";

import { useTranslation } from "react-i18next";
import NoDataIcon from "../../../../assets/svg/no-data.svg";

const customComColors = {
  "Community A": "#3BBEE8",
  "Community B": "#004877",
  "Community C": "#004"
};
const AgeVsCommunityChart = ({ isDataAvailable, graphData }) => {
  const { t } = useTranslation();
  const theme = {
    axis: {
      ticks: {
        text: {
          fontSize: 11,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      },
      legend: {
        text: {
          fontSize: 11,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      }
    }
  };
  return (
    <>
      {" "}
      <div className='revenue-map-chart' style={{ height: "300px" }}>
        {/* Use ResponsiveBar to render the graph */}
        {isDataAvailable > 0 ? (
          <>
            <div className='flex justify-between'>
              <div className='ml-4 mt-4 flex items-center legend'>
                {["Community A", "Community B", "Community C"].map((legend) => (
                  <div
                    key={legend}
                    className='mr-2 flex items-center'
                    style={{ color: customComColors[legend] }}
                  >
                    <div
                      className='w-3 h-3  mr-1'
                      style={{ backgroundColor: customComColors[legend] }}
                    ></div>
                    <span>{legend}</span>
                  </div>
                ))}
              </div>
            </div>
            <ResponsiveBar
              data={graphData}
              keys={["Community A", "Community B", "Community C"]}
              indexBy='age'
              margin={{ top: 10, right: 5, bottom: 40, left: 80 }}
              padding={0.3}
              layout='horizontal'
              colors={(e) => customComColors[e.id]}
              borderColor={{ from: "color", modifiers: [["darker", "1.6"]] }}
              axisTop={null}
              axisRight={null}
              axisBottom={{
                tickSize: 0,
                tickPadding: 0,
                tickRotation: 0,
                legend: "Age",
                legendPosition: "middle",
                legendOffset: 30,
                format: (value) => `${value}%`
              }}
              axisLeft={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend: "No. of People",
                legendPosition: "middle",
                legendOffset: -70
              }}
              theme={theme}
              enableGridY={false}
              enableLabel={false}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
              legends={[]}
              tooltip={({ id, value }) => (
                <strong className="text-color">{`${id}: ${value.toFixed(2)}%`}</strong>
              )}
            />
          </>
        ) : (
          <div className='no-data-icon'>
            {/* Handle case where data is not available */}
            <img src={NoDataIcon} alt=''></img>
            <h1>{t("No Data Available")}</h1>
          </div>
        )}
      </div>
    </>
  );
};

export default AgeVsCommunityChart;
